module.exports = __webpack_public_path__ + "static/media/Handheld2.347377e0.jpeg";